import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    text-align: right;
    height: 100%;

    svg {
        width: 18px;
        height: 18px;
        opacity: 0.5;
        padding: 3px;
    }
`;

export const Label = styled.p`
    margin: 0;
    padding: 0;
    align-items: center;
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1.2;
    letter-spacing: -0.03em;
    color: ${({ theme }) => theme.shades.white[50]};
`;
